import React from 'react';

type Props = {
  divider?: React.ReactNode;
  children: (React.ReactNode | false | null | undefined)[];
};

/*
DividerSeries can be used with fragments to group elements together, like this:
<DividerSeries divider={<HR />}>
  <>
    {showA && <A/>}
    {showB && <A/>}
  </>
  <>
    {showA && <A/>}
    {showB && <A/>}
  </>
</DividerSeries>
*/

export default function DividerSeries({ divider, children }: Props) {
  const filteredChildren = children.filter(Boolean).filter((child) => {
    //Also filter out empty fragments, i.e. <>undefined</>, since that frees you up to group elements together with those
    if (child && typeof child === 'object' && 'props' in child && child.type == React.Fragment) {
      const childChildren = (child as any).props?.children;
      return childChildren && (!Array.isArray(childChildren) || childChildren.some(Boolean));
    }
    return true;
  });

  return (
    <>
      {filteredChildren.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < filteredChildren.length - 1 && divider}
        </React.Fragment>
      ))}
    </>
  );
}
